<template>
<body>
  <div class="modalContainer active loginModal formsModal">
    <div class="actualModal">
      <!-- <a href="#" class="closeModal"><i class="fal fa-times"></i></a> -->
      <form @submit.prevent="handleSubmit" class="modalBodyOfItem">
        <div class="itemBodyLeftModal">
          <h4>Account Setup</h4>
          <div class="inputsContainer">
            <div class="individualInput">
              <h5>Full Name</h5>
              <input v-model="name" type="text" name="" id="" placeholder="John Doe" />
            </div>
            <div class="individualInput">
              <h5>Phone Number</h5>
              <input maxlength="16" v-model="phone" type="number" name="" id="" placeholder="8185555555" />
            </div>
          </div>
          <div class="mobileFlex"></div>
          <div class="quickCheckout">
            <div style="margin-bottom: 5px;" v-if="haserrors" class="error">Please complete the form.
            </div>
            <button type="submit">Continue</button>
          </div>
          <div class="formProgress">
            <p>1/3</p>
          </div>
        </div>
      </form>
    </div>
  </div>
</body>
</template>
<script>
import validator from 'validator'
export default {
  name: 'SignUp',
  data() {
    return {
      haserrors: false,
      name: '',
      phone: '',
      token: this.$route.query.token,
    }
  },
  created() {
    this.$store.dispatch('auth/fetchUser')
  },
  methods: {
  validateForm() {
    let {phone,name} = this
    let validPhone = validator.isMobilePhone(phone)
    // console.log(validPhone,phone,name)
    if(!name || !validPhone) return false
    if(name.indexOf(' ') == -1) return false
    return true
  },
    handleSubmit(e) {
      console.log('form submitted')
      this.submitted = true
      const {
        name,
        phone
      } = this
      if (name && phone) {
        if(!this.validateForm()) {
          return this.haserrors = true
        }
        this.$store.dispatch('setup/step1', {
          name,
          phone
        })
      } else {
        this.haserrors = true
      }
    }
  },
  watch: {
    '$route'(to, from) {
      // react to route changes...
      this.token = this.$route.query.token
    }
  }

}
</script>
<style>
.sign-up-page-wrapper {
  padding: 5px;
}
</style>
